module.exports = __webpack_public_path__ + "img/wdorder.4310e6f4.png";